import { useProduct } from '~/composables/custom/useProduct/useProduct';
import { useBFF } from '~/composables/useBFF/useBFF';

export const useSizeChart = () => {
  const { $i18n } = useNuxtApp();
  const route = useRoute();
  const { $magnolia } = useBFF();
  const { breadcrumbs } = useProduct(route.path);
  const { result: categories } = useCategories();

  const sizeChartContent = ref(undefined);

  const fetchSizeChartContent = async (category: string) => {
    try {
      const { data: content, errors } = await $magnolia.fetchContent(`/Size-Info/${category}`);
      sizeChartContent.value = content?.area1?.[content?.area1?.['@nodes']?.[0]]?.content;

      if (!sizeChartContent.value || errors.length) {
        category = $i18n.t('Generic').toString().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        const { data: content } = await $magnolia.fetchContent(`/Size-Info/${category}`);
        sizeChartContent.value = content?.area1?.[content?.area1?.['@nodes']?.[0]]?.content;
      }
    }
    catch {
      // swallow error to avoid breaking the page
    }
  };

  const handleSizeChartTable = async () => {
    const cat = breadcrumbs.value[0]?.text;
    if (cat && !hideChartSize.value) {
      let category = cat === $i18n.t('Girl') || cat === $i18n.t('Boys') ? $i18n.t('Children') : cat;
      category = category.normalize('NFD').replace(/\p{Diacritic}/gu, '');
      await fetchSizeChartContent(category);
    }
  };

  const hideChartSize = computed(() => {
    const breadcrumbsNames = breadcrumbs.value?.map(b => b.text);
    const breadcrumbsCategories = [];
    const getChildren = (category: NavbarCategory, index: number) => {
      if (category.name === breadcrumbsNames.at(-1)) {
        return;
      }
      const children = category.childrenItems?.find(child => child.name === breadcrumbsNames[index]);
      if (children) {
        breadcrumbsCategories.push({
          name: children.name,
          hideChartSize: children.hideChartSize,
        });
        getChildren(children, index + 1);
      }
    };

    const first = categories.value?.find(child => child.name === breadcrumbsNames[0]);
    if (first) {
      breadcrumbsCategories.push(first);
      breadcrumbsNames.forEach((_, index) => {
        getChildren(first, index + 1);
      });
    }
    return breadcrumbsCategories?.some(breadcrumbCategory => breadcrumbCategory?.hideChartSize);
  });

  return {
    sizeChartContent: computed(() => sizeChartContent.value),
    hideChartSize,
    handleSizeChartTable,
  };
};
